import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function FooterOneComponent() {
  return (
    <div className="footer-main-new">
      <div className="container">
        <Row>
          <Col xs={12} md={4}>
            <motion.div
              className="footer-brand-new"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h4 className="footer-logo-new">
                GoWave{" "}
                <span style={{ color: "#63FFCD" }}>Automation Lab</span>
              </h4>
              <p className="footer-tagline-new">
                A registered partnership firm building AI-powered enterprise
                software for businesses worldwide.
              </p>
              <div className="footer-socials">
                <a href="https://facebook.com/gowave009" target="_blank" rel="noopener noreferrer" className="social-link-new">
                  <span className="fa fa-facebook"></span>
                </a>
                <a href="https://www.linkedin.com/company/gowave" target="_blank" rel="noopener noreferrer" className="social-link-new">
                  <span className="fa fa-linkedin"></span>
                </a>
                <a href="https://github.com/Jeet009" target="_blank" rel="noopener noreferrer" className="social-link-new">
                  <span className="fa fa-github"></span>
                </a>
                <a href="mailto:contact@gowave.in" className="social-link-new">
                  <span className="fa fa-envelope"></span>
                </a>
              </div>
            </motion.div>
          </Col>

          <Col xs={6} md={2}>
            <motion.div
              className="footer-links-new"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <h6 className="footer-col-title">Products</h6>
              <a href="https://www.classscribe.in" target="_blank" rel="noopener noreferrer" className="footer-link-new">ClassScribe</a>
              <a href="https://hms-gowave.vercel.app" target="_blank" rel="noopener noreferrer" className="footer-link-new">HMS</a>
              <a href="https://likar.app" target="_blank" rel="noopener noreferrer" className="footer-link-new">LiKAR</a>
            </motion.div>
          </Col>

          <Col xs={6} md={2}>
            <motion.div
              className="footer-links-new"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <h6 className="footer-col-title">Company</h6>
              <Link to="/" className="footer-link-new">Home</Link>
              <Link to="/portfolio" className="footer-link-new">Portfolio</Link>
              <a href="mailto:contact@gowave.in" className="footer-link-new">Contact</a>
              <a href="https://m.me/gowave009" className="footer-link-new" target="_blank" rel="noopener noreferrer">Chat</a>
            </motion.div>
          </Col>

          <Col xs={12} md={4}>
            <motion.div
              className="footer-newsletter-new"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <h6 className="footer-col-title">Stay Updated</h6>
              <p className="footer-newsletter-desc">
                Get the latest updates on our products and services.
              </p>
              <div className="newsletter-form-new">
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  className="newsletter-input-new"
                />
                <button className="btn btn-custom newsletter-btn">
                  Subscribe
                </button>
              </div>
            </motion.div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default FooterOneComponent;
